import angular from 'angular';
import moment from 'moment';
import { TipoJustificativaEnum } from '../../../../shared/enums/TipoJustificativaEnum';
import { IFalta } from '../models/falta.model';
import { ITrabalhador } from 'modules/Trabalhadores/models/trabalhador.model';
import { Empresa, Estabelecimento } from '../../../../core/usuario/models/usuario-model';
import { ListagemService } from '../../../../shared/services/listagem.service';
import { TrabalhadoresService } from '../../../Trabalhadores/trabalhadores.service';

export class MeurhSolicitacoesfaltasFormController implements angular.IController {
	static $inject = [
        '$scope',
        '$stateParams',
        '$rootScope',
        'ListagemService',
        'TrabalhadoresService',
    ];

	public tipo: string = this.$stateParams['tipo'] ? this.$stateParams['tipo'] : '-1';
	public entity: IFalta;
	public form: angular.IFormController;
	public enum = TipoJustificativaEnum;
    public busy: boolean = false;
    public action: string;

    public filters = {
        empresa: this.$rootScope.session.entities.empresa.empresa,
        estabelecimento: this.$rootScope.session.entities.estabelecimento.estabelecimento
    };
    public empresas: Empresa[];
    public estabelecimentos: Estabelecimento[];
    public listagemPermissao: string[] = ['criar_falta'];
    public permissaoGrupoEmpresarial = this.$rootScope.temPermissaoGrupoEmpresarial(this.listagemPermissao, this.$rootScope.nsjGlobals.a.grupoempresarial);

    public constructorLookupColaborador = {};

	constructor(
		public $scope: angular.IScope,
		public $stateParams: angular.ui.IStateParamsService,
		public $rootScope: angular.IRootScopeService & {
            temPermissao: (arg: string) => boolean,
            modoGestorPermissao: (arg: string) => boolean,
            temPermissaoGrupoEmpresarial: (permissoes: string[], grupo: string) => boolean,
            liberadoTela: (arg: string) => boolean,
            session: any,
            nsjGlobals: any,
        },
        public ListagemService: ListagemService,
        public TrabalhadoresService: TrabalhadoresService,
	) {
        $scope.$on('persona_trabalhadores_loaded', (event, args: ITrabalhador) => {
            this.busy = false;
            this.entity.trabalhador.situacao = args.situacao;
            this.form.datas.$setValidity('colaboradorAfastado', this.isDataFaltaAntesDoAfastamento());
            if (this.action === 'update') {
                this.form.datas.$setDirty();
            }
        });

        $scope.$watch('$ctrl.entity.datas', (newValue?: string, oldValue?: string) => {
			if (newValue !== oldValue) {
                const isDataVazia = newValue === '' ||
                    newValue === undefined ||
                    newValue.length === 0;

				this.form.datas.$setValidity('required', !isDataVazia);
                this.form.datas.$setValidity('colaboradorAfastado',
                    !this.isColaboradorAfastado(this.entity.trabalhador.status) ||
                    this.isDataFaltaAntesDoAfastamento()
                );
			}
		}, true);

        $scope.$watch('$ctrl.entity.trabalhador', (newValue: ITrabalhador, oldValue: ITrabalhador) => {
            if (newValue !== oldValue) {
                if (newValue && this.isColaboradorAfastado(newValue.status)) {
                    this.busy = true;
                    this.TrabalhadoresService.get(this.entity.trabalhador.trabalhador);
                }
            }
        }, true);
	}

    $onInit(): void {
        this.montaListagemVisibilidade();

        this.constructorLookupColaborador = {
            'empresa': this.filters.empresa,
            'estabelecimento': this.filters.estabelecimento,
            'status': '00',
            'forcagestor': this.forcaGestor(),
            ...(this.tipo && { 'tipo': this.tipo }),
        };
    }

    isColaboradorAfastado(status: string | null) {
        const statusAfastamento = ['03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15'];
        return statusAfastamento.includes(status);
    }

    isDataFaltaAntesDoAfastamento() {
        const dataFalta = moment(this.entity.datas).startOf('day');
        const dataAfastamento = moment(this.entity.trabalhador.situacao.data).startOf('day');
        return dataFalta.isBefore(dataAfastamento);
    }

    montaListagemVisibilidade(): void {
        if (this.action === 'update') {
            this.filters.empresa = this.entity.estabelecimentoobj.empresa;
            this.filters.estabelecimento = this.entity.estabelecimentoobj.estabelecimento;
        }
        this.empresas = this.ListagemService.montaEmpresas(this.$rootScope.nsjGlobals.a.grupoempresarial, this.listagemPermissao);
        this.estabelecimentos = this.ListagemService.montaEstabelecimentos(this.filters.empresa, this.empresas, this.listagemPermissao);
    }

    mudaEstabelecimentos(): void {
        this.estabelecimentos = this.filters.empresa ? this.ListagemService.montaEstabelecimentos(this.filters.empresa, this.empresas, this.listagemPermissao) : [];
        this.filters.estabelecimento = '';
        this.filtraEmpresaEstabelecimento();
    }

    filtraEmpresaEstabelecimento(): void {
        this.constructorLookupColaborador = {
            'empresa': this.filters.empresa,
            'estabelecimento': this.filters.estabelecimento,
            'status': '00',
            'forcagestor': this.forcaGestor(),
            ...(this.tipo && { 'tipo': this.tipo }),
        };
    }

	forcaGestor(): boolean {
		return this.$rootScope.modoGestorPermissao('criar_falta');
	}

	mudarTipo(): void {
		this.entity.justificada = this.entity.justificadaSelect === '0' ? false : true;

		if (!this.entity.justificada) {
			this.entity.justificativa = '';
			this.entity.tipojustificativa = '';
		}
	}
}
